export default "__VITE_ASSET__DQZeIJJA__"